<template>
  <div class="w100 h100 positon-relative">
    <div class="cont position-absolute">
      <div class="p24">
        <div class="title center d-flex align-items-center justify-content-center ">
          <!-- <div class="line fl-line"></div> -->
          <img src="../assets/img/news/line.png" alt="" srcset="" class="fl-line">
          <div class="ml-24 mr-24">{{ detail.title }}</div>
          <img src="../assets/img/news/line.png" alt="" srcset="">

        </div>

        <div class="time center mt-24 mb-36">
          {{ common.tsformat(detail.time) }}
        </div>
        <div class="d-cont" v-html="detail.context"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: null,
    };
  },
  created() {
    this.handleDetail(this.$route.query.id);
  },
  methods: {
    handleDetail(id) {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      const params = {
        id,
      };
      params.signature = this.common.makeSignature(params, reqTime);
      params.reqTime = reqTime;
      this.$axios({
        method: "post",
        url: "news/view",
        data: params,
        //withCredentials:true, //局部携带cookie
        headers: {}, //如果需要添加请求头可在这写
      })
        .then((res) => {
          this.detail = res.data.data;
          console.log(res.data.data);
        })
        .catch((err) => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });
    },
  },
};
</script>

<style scoped lang="scss">
.cont {
  background: url("../assets/img/news/new-cont.png") no-repeat center top;
  background-size: 100% 100%;
  width: 1556px;
  height: 840px;
  overflow-y: scroll;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-size: 40px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #ffffff;
    text-shadow: 0 0 10px #e7c16c, 0 0 20px #e7c16c, 0 0 40px #e7c16c,
      0 0 0px #e7c16c;
    padding-top: 66px;
  }
  .line {
    background: url("../assets/img/news/new-cont.png") no-repeat center top;
    background-size: 100% 100%;
    width: 42px;
    height: 1px;
  }
  .fl-line {
    transform: rotate(180deg);
  }
  .time {
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #f8e09d;
  }
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 0 !important;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.1);
  border-radius: 1px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 1px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.1);
}
.d-cont {
   white-space: pre-wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/NewsEvent.vue